import { baseApi } from '@/utils/requestConfig'

// home
export function getFutureAppointments() {
  return baseApi.get('/my-termine/mitglied/termine', {
    params: { zukuenftige: true, vergangene: false, include: 'dienstleistung' },
  })
}

export function getPastAppointments() {
  return baseApi.get('/my-termine/mitglied/termine', {
    params: { zukuenftige: false, vergangene: true, include: 'dienstleistung' },
  })
}

export function exportAppointment(id) {
  return baseApi.get('/my-termine/termine/' + id + '/download/calendar', {
    responseType: 'blob',
  })
}

export function deleteAppointment(id) {
  return baseApi.delete('/my-termine/termine/' + id)
}

export function getFederalStates() {
  return baseApi.get('/my-termine/bundeslaender', {
    headers: {
      'Cache-Control': 'max-age=172800',
    },
  })
}

export function getLandesclubsTelephone() {
  return baseApi.get('/my-termine/landesclubs', {
    headers: {
      'Cache-Control': 'max-age=172800',
    },
  })
}

// services
export function getServices(state) {
  return baseApi.get('/my-termine/booking/snr', {
    params: { landesclubId: state },
    headers: {
      'Cache-Control': 'max-age=7200',
    },
  })
}

// vehicles
export function getKfzartId(params) {
  return baseApi.get('/my-termine/fahrzeuge/kfzarten', {
    params,
    headers: {
      'Cache-Control': 'max-age=7200',
    },
  })
}

// stations
export function getStationCoordinates(params) {
  return baseApi.get('/my-termine/dienststellen/coordinates', {
    params,
    headers: {
      'Cache-Control': 'max-age=7200',
    },
  })
}

export function getStationBookingInfo(id) {
  return baseApi.get('/my-termine/dienstleistungsangebote/' + id)
}

// appointment
export function getAppointmentTimeslots(payload, params) {
  return baseApi.post('/my-termine/booking/terminsuche', payload, { params })
}

/**
 * Get monthly availability for appointment booking.
 * This endpoint provides the monthly utilization of the appointment calendar
 * for a given start date, dienststelle, kfzart and snrs.
 *
 * @param {Object} payload - The payload containing search parameters
 * @param {string} payload.datum - The start date in YYYY-MM-DD format
 * @param {number} payload.dienststelleId - The ID of the service point
 * @param {number[]} payload.snrs - Array of service number IDs
 * @param {number} payload.kfzartId - The vehicle type ID
 * @returns {Promise} A promise that resolves to the monthly availability response
 * @returns {Object} response.data.items - Object with date keys and boolean availability values
 * @example
 * // Response format:
 * {
 *   "items": {
 *     "2025-08-06": false,
 *     "2025-08-07": true,
 *     "2025-08-08": true,
 *     // ... more dates
 *   },
 *   "totalElements": 22
 * }
 */
export function getMonthlyAppointmentAvailability(payload) {
  return baseApi.post('/my-termine/booking/terminsuche/monthly', payload)
}

export function lockAppointmentTimeslot(id, payload) {
  return baseApi.post('/my-termine/booking/locktermin/' + id, payload)
}

/** extend duration of locked appointment by 10 minutes per default */
export function extendAppointmentLock(id) {
  return baseApi.put(`/my-termine/termine/${id}/locktimeout`)
}

// overview
export function checkMembershipFeatures() {
  return baseApi.get('/my-termine/mitglied/merkmale')
}

export function checkMembershipContract(params) {
  return baseApi.get('/my-termine/mitglied/vertragscheck', { params })
}

export function updateAppointmentContact(payload) {
  return baseApi.put('/my-termine/termine/contact', payload)
}

export function confirmAppointment(payload) {
  return baseApi.post('/my-termine/booking/confirm', payload)
}

export function confirmAppointmentToUser(payload) {
  return baseApi.post('/my-termine/termine/confirm', payload)
}

/**
 * Notify about a deleted appointment via SMS.
 *
 * @param {Object} payload - The payload containing the appointment details.
 * @param {number} payload.terminId - The ID of the deleted appointment.
 */
export function notifyDeletedAppointmentSms(payload) {
  return baseApi.post('/my-termine/notification/sms/deletedTermin', payload)
}

/**
 * Notify about a deleted appointment via Email.
 *
 * @param {Object} payload - The payload containing the appointment details.
 * @param {number} payload.terminId - The ID of the deleted appointment.
 */
export function notifyDeletedAppointmentEmail(payload) {
  return baseApi.post('/my-termine/notification/email/deletedTermin', payload)
}

// general
export function getText(id) {
  return baseApi.get('/my-termine/texte/' + id)
}
